import { Col, Divider, Row } from 'antd';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import BarChart from '../../../../components/DashboardPage/BarChart';
import ReportTable from '../../../../components/DashboardPage/ReportTable';
import { generateReportQueryStringFromQuery } from '../TicketReport/TicketReportFiltersContainer';

const AgentReportItemsContainer = () => {
    const { query } = useRouter();
    const { t } = useTranslation('reports');
    const queryString = generateReportQueryStringFromQuery(query);
    return (
        <>
            <Row style={{ justifyContent: 'space-evenly' }}>
                <Col span={20}>
                    <BarChart
                        url={queryString ? `/reports/agents/hourly-active-agents?${queryString}` : null}
                        title={t('agentReports.reportItems.countOfHourlyActiveAgents')}
                    />
                </Col>
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }}>
                <Col span={20}>
                    <ReportTable
                        agentSearchable
                        url={queryString ? `/reports/agents/general-agent-report?${queryString}` : null}
                        title={t('agentReports.reportItems.agentReportGeneral')}
                    />
                </Col>
            </Row>
            <Divider />
            <Row style={{ justifyContent: 'space-evenly' }}>
                <Col span={20}>
                    <ReportTable
                        agentSearchable
                        url={queryString ? `/reports/agents/efficiency-report?${queryString}` : null}
                        title={t('agentReports.reportItems.performanceEfficiencyTable')}
                    />
                </Col>
            </Row>
            <Divider />
            {/* <Row justify="center" style={{ gap: '10px 10px' }}>
                <Col span={20}>
                    <ReportTable
                        url={ queryString ?`/reports/agents/agent-success?${queryString}`: null}
                        title={t('agentReports.reportItems.successTable')}
                    />
                </Col>
            </Row> */}
        </>
    );
};

export default AgentReportItemsContainer;
